import { usePoiStore } from './store';
import { PoiLayer } from './PoiLayer';

// Renders all currently active POI categories as Leaflet layers.
// Must be a child of MapContainer (i.e. inside <BaseMap>).
export function PoiLayers() {
  const active = usePoiStore((s) => s.active);
  return (
    <>
      {Array.from(active).map((cat) => (
        <PoiLayer key={cat} category={cat} />
      ))}
    </>
  );
}
